import { cleanUndefinedKeysRecurse } from '../lib/util';
import UserRole from './UserRole';
import { userRoleTypes } from './userTypes';

/**
 * @typedef {import('./UserRole').UserRoleData & ChildClassData} UserCompanyRoleData
 * @combinedata
 */
/**
 * @typedef {Object} ChildClassData
 * @property {number} _userCompanyRoleDataVer
 * @ignore
 */

const latestDataVer = 1;

export default class UserCompanyRole extends UserRole {
	static _targetType = userRoleTypes.company;

	/**
	 * @param {UserCompanyRoleData} inputData 
	 */
	constructor(inputData) {
		super(inputData);
	}

	/**
	 * @param {UserCompanyRoleData} inputData 
	 */
	_reInit(inputData) {
		super._reInit(inputData);
		this._userCompanyRoleDataVer = inputData._userCompanyRoleDataVer || latestDataVer;

		if (this._userCompanyRoleDataVer !== latestDataVer) { throw new Error(`Metadata version not latest: Got '${this._userCompanyRoleDataVer}', should be '${latestDataVer}'`); }
	}

	serialize() {
		const ser = {
			...super.serialize(),
			_userCompanyRoleDataVer: this._userCompanyRoleDataVer,
		};

		return cleanUndefinedKeysRecurse(ser);
	}

	getUpdatableData() {
		// we can only request to directly update these
		const updates = {
			...super.getUpdatableData(),
			_userCompanyRoleDataVer: this._userCompanyRoleDataVer, // even though we can't technically update this, send it so the backend can throw if we are sending the wrong data ver
		};

		return cleanUndefinedKeysRecurse(updates);
	}
}